import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import {
  ACTION_LOAD_CERTIFICATE_STATUS__REQUEST,
  ACTION_LOAD_CERTIFICATE_STATUS__SUCCESS,
  ACTION_LOAD_CERTIFICATE_STATUS__FAIL,
} from '../../actionTypes';


const byHostName = (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_CERTIFICATE_STATUS__REQUEST:
    case ACTION_LOAD_CERTIFICATE_STATUS__SUCCESS:
      return _omit(state, [action.payload.hostName]);

    case ACTION_LOAD_CERTIFICATE_STATUS__FAIL: {
      const { hostName, error } = action.payload;

      return { ...state, [hostName]: error };
    }

    default:
      return state;
  }
};

export default combineReducers({
  byHostName,
});
